import BoundaryType from "../../enum/BoundaryType";
import BoundaryLegend from "../../types/map/BoundaryLegend";

export const isTerritoryBoundaryLegend = (legend: BoundaryLegend) =>
  legend.view === BoundaryType.TERRITORY;

export const isGeographyBoundaryLegend = (legend: BoundaryLegend) =>
  legend.view === BoundaryType.GEOGRAPHY;
